import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import '../Css/Navbar.css';
import { FaRegUserCircle } from "react-icons/fa";
import { IoSettingsOutline } from "react-icons/io5";
import { FiLogOut } from "react-icons/fi";
import { IoMdPrint } from "react-icons/io";
// Material UI
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, DialogContentText } from '@mui/material';
import { Construction } from '@mui/icons-material';
import Logger from './Logger';
import Swal from "sweetalert2";
import { getLoggerBaseURL } from '../utils/getLoggerBaseURL';

const NavbarPacker = () => {
    const [userDropdown, setUserDropdown] = useState(false);
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);
    const location = useLocation();

    // for details
    const userEmail = sessionStorage.getItem('userEmail');
    const role = sessionStorage.getItem("role");
    const [userName, setUserName] = useState('');
    const [organization, setUserOrgaizationName] = useState('');

    // Initialize Logger
    const logger = useRef(new Logger(getLoggerBaseURL())).current;

    let permission = {};
    const permissionString = sessionStorage.getItem("permissions");
    if (permissionString) {
        permission = JSON.parse(permissionString);
    } else {
        logger.log('Permission missing', 'ERROR');
    }

    const isActive = (path) => {
        return location.pathname === path ? "active-link" : "";
    };

    const navigate = useNavigate();

    const toggleUserDropdown = () => {
        setUserDropdown(!userDropdown);
    };

    const handleClose = () => {
        setOpen(false);
    };

    function homePage() {
        window.location.href = '/packerLanding';
    }

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await fetch(`/api/getUsersEmail/${userEmail}`);
                if (response.ok) {
                    const userData = await response.json();
                    setUserName(userData.user.name);
                    setUserOrgaizationName(userData.user.organization);
                } else {
                    logger.log('Failed to fetch user data for Navbar', 'ERROR');
                }
            } catch (error) {
                logger.log(`Error fetching user data: ${error.message}`, 'ERROR');
            }
        };

        if (userEmail) {
            fetchUserData();
        }
    }, [userEmail, logger]);

    const handleLogout = (e) => {
        e.preventDefault();
        // Show confirmation dialog before proceeding with logout
        Swal.fire({
            title: "Are you sure?",
            text: "You will be logged out of your account.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, Logout!",
            cancelButtonText: "Cancel",
            customClass: {
                popup: 'swal-popup',  // Custom class for the popup container
            },
            willOpen: () => {
                // Apply inline styles
                document.querySelector('.swal-popup').style.padding = '20px';  // Add padding here
            }
        }).then((result) => {
            // If the user confirms the logout action
            if (result.isConfirmed) {
                // Proceed with logout actions
                logoutUser();
            }
        });
    };

    const logoutUser = async () => {
        try {
            const response = await fetch(`/api/signup/logout/${userEmail}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error("Failed to log out");
            }

            // Remove session data
            sessionStorage.removeItem("drivers");
            sessionStorage.removeItem("permissions");
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("companyName");
            sessionStorage.removeItem("address");
            sessionStorage.removeItem("phoneNo");

            // Show success alert
            Swal.fire({
                title: "Logged Out!",
                text: "You have been successfully logged out.",
                icon: "success",
                timer: 1500,
                showConfirmButton: false,
            });

            // Navigate to home page after a short delay
            setTimeout(() => {
                navigate("/");
            }, 1500);
        } catch (error) {
            logger.log(`Error during logout: ${error.message}`, 'ERROR');
            Swal.fire({
                title: "Error!",
                text: "Failed to log out. Please try again.",
                icon: "error",
                willOpen: () => {
                    // Apply inline styles to add padding
                    document.querySelector('.swal-popup').style.padding = '20px';  // Add padding here
                }
            });
        }
    };

    // **Close dropdown when clicking outside**
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setUserDropdown(false);
            }
        };

        if (userDropdown) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [userDropdown]);

    return (
        <div className="navbar-container">
            <nav>
                <div className="title" onClick={homePage} style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: "20px", cursor: "pointer", }}>
                    <img src="https://zordigo.com/assets/Logo2.png" alt="Zordigo Logo" style={{ height: "40px", width: "auto", objectFit: "contain", }} />
                    <b style={{ color: "#c1272c", fontSize: "35px", lineHeight: 1, margin: 0, }}>Zordigo</b>
                </div>
                <ul>
                    <li className={`l ${isActive("/getQueue")}`}><Link to="/getQueue?limited=true">Print Requests</Link></li>
                    <li className="iconFace">
                        <FaRegUserCircle onClick={toggleUserDropdown} className={`userDropdown-btn ${userDropdown ? 'open' : ''}`} />
                        {userDropdown && (
                            <div ref={dropdownRef} className={`userDropdown-contentt ${userDropdown ? 'show' : ''}`}>
                                <p className='userAndCompanyName'>{userName && <p className='userAndCompanyName'><b>{userName}</b></p>}</p>
                                <p className='userAndCompanyName'>{organization && <p className='userAndCompanyName'>{organization}</p>}</p>
                                <hr />
                                {role === "admin" || (role === "dispatcher" && (permission.orderCreation || permission.orderUpload)) ? (
                                    <li>
                                        <Link to="/settings">
                                            <div className="link-content">
                                                <IoSettingsOutline className="iconDi" />
                                                <span className="link-text">Settings</span>
                                            </div>
                                        </Link>
                                    </li>
                                ) : null}
                                <li><Link to="/getQueue?limited=true">
                                    <div className="link-content">
                                        <IoMdPrint className="iconDi" />
                                        <span className="link-text">Print Requests </span></div></Link></li>
                                <hr />
                                <li>
                                    <Link to="/" onClick={handleLogout}>
                                        <FiLogOut className="iconDi" /><span className="link-text"> Log Out </span></Link></li>
                            </div>
                        )}
                    </li>
                </ul>
            </nav>
            <Dialog open={open} onClose={handleClose} PaperProps={{
                style: { width: '370px', backgroundColor: '#f0f8ff', borderRadius: '10px', padding: '18px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', },
            }}>
                <DialogTitle>
                    <Construction style={{ color: '#f44336', fontSize: '2rem', verticalAlign: 'middle' }} />
                    <Typography variant="h6" component="span" style={{ marginLeft: '10px' }}>
                        Under Construction
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Typography variant="body1" style={{ fontWeight: 500, color: '#444' }}>
                            This section is currently under development. Please check back later for updates.
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant="contained" color="primary" style={{ backgroundColor: '#1976d2' }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default NavbarPacker;